import React from 'react'

import Multiline from '../layouts/Multiline.jsx'

import useRequest from '../hooks/useRequest.js'
import { getKECCTrends } from '_services/insights-v2.js'
import { formatKECC } from '../../charts/helpers/formatters.js'

// Recent Trends by Topics
const Seasonality = (props) => {
  const {
    audience: { _id: audienceId },
  } = props
  const { data, index } = props
  const { time_frame, time_range, y_labels, title, description, selected_entities } = data

  const kecc = selected_entities.map((entity) => {
    if (typeof entity === 'string') return entity
    return entity.orig_name
  })

  let { data: response, loading } = useRequest(
    getKECCTrends,
    { audienceId, kecc, keccType: 'keywords', timeRange: time_range },
    !!kecc?.length
  )

  const multilineData = formatKECC({
    raw: response,
    names: kecc,
    timeFrame: time_frame,
    type: y_labels,
  })

  return (
    <Multiline
      title={title}
      description={description}
      page={index + 1}
      timeFrame={time_frame}
      isLoading={loading}
      data={multilineData}
      yLabel={y_labels}
    />
  )
}

export default Seasonality
